<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Incentive & Penalty Management
                        <button class="btn btn-blue btn-icon float-right" (click)="openModal(null)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <!-- Filters -->
                        <form>
                            <div class="row mb-3">
                                <div class="col-xl-3">
                                    <label class="control-label">{{EnableHumanMMU ? 'MMU' : 'MVU'}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" [(ngModel)]="MVU"
                                            [ngModelOptions]="{standalone: true}" >
                                            <option value="-1">All</option>
                                            <!-- <option value="-1">All</option> -->
                                            <option *ngFor="let item of mvuLst" [value]="item.mvu_id">
                                                {{item.mvu_name}}</option>
                                        </select>
                                        <!-- <div *ngIf="submitted && f.work_location_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.work_location_id.errors.required"> {{EnableHumanMMU ? 'MMU' :
                                                'MVU'}} is required
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                                 <div class='col-xl-3'>
                                <div class="form-group">
                                    <div class='date' id='datetimepicker6'>
                                        <label class="control-label">Month & Year<span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input id="start_date" name="start_date" type="text" autocomplete="off"
                                                onpaste="return false" placeholder="From" bsDatepicker
                                                #dp="bsDatepicker" (focus)="dp.show()" [(ngModel)]="start_date"
                                                [ngModelOptions]="{standalone:true}" 
                                                [maxDate]="max_date" onkeypress='return event.charCode == 8'
                                                [bsConfig]="{ dateInputFormat: 'MM-YYYY', showWeekNumbers: false,   minMode: 'month'}"
                                                class="form-control form-control-sm">
                                            <!-- <div *ngIf="submitted && f.start_date.errors" class="invalid-feedback">
                                                <div *ngIf="f.start_date.errors.required">From Date is required</div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <!-- <div class="col-xl-3">
                                    <div class="form-group">
                                        <label class="control-label">Role <span class="text-danger">*</span> </label>
                                        <div>
                                            <select id="user_type_id" class="form-control form-control-sm"
                                                [(ngModel)]="user_type_id" [ngModelOptions]="{standalone: true}">
                                                <option value="">Select</option>
                                                <option *ngFor="let role of roleList" [value]="role.role_id">
                                                    {{role.role_name}}</option>
                                            </select>
                                            <div *ngIf="submitted && f.user_type_id.errors" class="invalid-feedback">
                                                <div *ngIf="f.user_type_id.errors.required">Role is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class='col-md-5' style="margin-top: 2rem;">
                                    <button type="submit" class="btn btn-sm btn-primary" value="Submit"
                                        (click)="LoadData()">Submit</button>&nbsp;&nbsp;
                                        <button type="submit" class="btn btn-sm btn-secondary" value="Excel" title="All MMU with employee Details"
                                        (click)="ExportExcel()"> <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Excel</button>&nbsp;&nbsp;
                                        <button type="submit" class="btn btn-sm btn-warning" value="Email"
                                        (click)="sendMail()" *ngIf="isEnableSendMail"> <i class="fas fa-envelope"></i>&nbsp;&nbsp;Send Mail</button>&nbsp;&nbsp;
                                </div>
                            </div>
                        </form>

                        <!-- Table -->
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-sm" style="width:100%" datatable
                                [dtOptions]="dtOptions" *ngIf="dtRender">
                                <thead>
                                    <tr>
                                        <th class="text-center">S.No</th>
                                        <th>MMU Name</th>
                                        <th>Co-ordinator Name</th>
                                        <!-- <th>Doctor Name</th> -->
                                        <th class="text-danger">Deduction</th>
                                        <th class="text-success">Incentive</th>
                                        <!-- <th>Total</th>
                                        <th>Driver Name</th>
                                        <th class="text-danger">Deduction</th>
                                        <th class="text-success">Incentive</th>
                                        <th>Total</th>
                                        <th>Nurse</th>
                                        <th class="text-danger">Deduction</th>
                                        <th class="text-success">Incentive</th>
                                        <th>Total</th> -->
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of lstGrid; let i = index">
                                   <td>{{i+1}}</td>
                                   <td>{{item?.mvu_name}}</td>
                                   <td>{{item?.coordinator_name}}</td>
                                   <td>{{item?.penalty_amount}}</td>
                                   <td>{{item?.incentive_amount}}</td>
                                <td>
                                    <div class="badge badge-info badge-pill pointer">
                                        <a (click)="openModal(item)">
                                            <i class="fa fa-edit text-white"></i>
                                        </a>
                                    </div>
                                </td>
                                </tr>
                                </tbody>
                                
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>